export default __webpack_public_path__ + "static/media/synced-up-1.514a7a58.jpg";